import React from 'react';
import styles from './Onboarding.module.css';
import { brandImages } from '../../theme/brandAssets';

const Topbar = () => {

  return (
    <div className={`${styles['frow']} `} style={{padding:"10px 120px", background:"#F2F6FA"}}>
        <div>
          <a href='https://kynzo.io/'>
          <img className="brand-logo-img" style={{maxHeight:40, width:'auto'}} src={brandImages.wordmarkOnLight} alt='Kynzo'></img>
          <span style={{marginLeft:"10px"}}>Kynzo</span>
          </a>
          
        </div>
    </div>
  );
};
export default Topbar;
